// Copyright (c) 2024 WiseTime. All rights reserved.

export const shortcuts = {
  timeMarker: "m",
  manualTime: "t",
  timeGroup: "n",
  timesheetsConsole: "`",
}
